import { render, staticRenderFns } from "./header-main-menu.vue?vue&type=template&id=3dbdda4e&scoped=true&"
import script from "./header-main-menu.vue?vue&type=script&lang=js&"
export * from "./header-main-menu.vue?vue&type=script&lang=js&"
import style0 from "./header-main-menu.vue?vue&type=style&index=0&id=3dbdda4e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbdda4e",
  null
  
)

export default component.exports